/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Server-managed provenance; not writable via create/update
 * @export
 */
export const VendorErrorSource = {
    Manual: 'MANUAL',
    UnresolvedQueue: 'UNRESOLVED_QUEUE'
} as const;
export type VendorErrorSource = typeof VendorErrorSource[keyof typeof VendorErrorSource];


export function instanceOfVendorErrorSource(value: any): boolean {
    for (const key in VendorErrorSource) {
        if (Object.prototype.hasOwnProperty.call(VendorErrorSource, key)) {
            if (VendorErrorSource[key as keyof typeof VendorErrorSource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function VendorErrorSourceFromJSON(json: any): VendorErrorSource {
    return VendorErrorSourceFromJSONTyped(json, false);
}

export function VendorErrorSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): VendorErrorSource {
    return json as VendorErrorSource;
}

export function VendorErrorSourceToJSON(value?: VendorErrorSource | null): any {
    return value as any;
}

export function VendorErrorSourceToJSONTyped(value: any, ignoreDiscriminator: boolean): VendorErrorSource {
    return value as VendorErrorSource;
}

